import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useParams } from "react-router-dom";

const AuthorizePage = () => {
  const [loading, setLoading] = useState(false);
  const { invoiceId } = useParams();

  useEffect(() => {
    if (!invoiceId) {
      Swal.fire({
        icon: "error",
        title: "Invalid Request",
        text: "Something went wrong!",
      });
      setLoading(false);
      return;
    }

    axios
      .put(`${process.env.REACT_APP_BASE_URL}/invoices/authorize/${invoiceId}`)
      .then((response) => {
        if (response?.data.success) {
          Swal.fire({
            icon: "success",
            title: "Authorized!",
            text: "✅ You have authorized your payment successfully.",
            confirmButtonColor: "#3085d6",
          });
        }
      })
      .catch((error) => {
        if (!error?.response?.data.success) {
          Swal.fire({
            icon: "error",
            title: "Authorization Failed",
            text: `${error?.response?.data.message}`,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [invoiceId]);

  return (
    <div className="flex items-center justify-center h-screen bg-white">
      {loading && (
        <div className="flex flex-col items-center space-y-4">
          {/* Spinner */}
          <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
          {/* Text */}
          <h2 className="text-lg font-semibold text-gray-700">
            Authorizing...
          </h2>
        </div>
      )}
    </div>
  );
};

export default AuthorizePage;
